import axios from "axios";
const getOpenAI = async (data) => {
  const response  = await axios.post(
    "https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions",
    data,
    {
      headers: {
        Authorization: "Bearer sk-a8584faf05104f6e8a5477fdf167ec4a",
        "Content-Type": "application/json",
      },
    }
  )
  return response;
};

export default {
  getOpenAI,
};
